import React, { useEffect, useState } from "react"
import {  Row, Col, Collapse, UncontrolledCollapse } from "reactstrap"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import styled, { css } from "styled-components"
import { LinkSearchReplace } from "utils/LinkSearchReplace"
import { media } from "utils/Media"
import { useDishContext } from 'components/FlexibleContent/Blocks/Listing/ListingMenus';

const DishesWrap = styled.div`
  max-width: 700px;
  background-color: white;
  z-index: 11;
  line-height: 1.1;

  h3 {
    /* font-size: ${props => props.theme.font.size.sm}; */
    text-transform: uppercase;
    margin-bottom: 0;
    padding-bottom: 1rem;
    
    /* @media ${media.md} { */
      font-size: ${props => props.theme.font.size.lg};
    /* } */
  }

  .content-items {
    font-size: ${props => props.theme.font.size.sm};
    padding-bottom: 1rem;
    padding-left: 1.5rem;
    line-height: 1.4;
    
    h5 {
      text-transform: uppercase;
      font-size: ${props => props.theme.font.size.sm};
      margin-bottom: 0.25rem;
    }
  }

  .dish-button {
    background-color: transparent;
    border: 0;
    padding: 0;
    position: relative;
    color: ${props => props.theme.colors.black};
    
    .icon {
      position: absolute;
      left: -1.5rem;
      top: .05rem;
      font-size: 1.2rem;
      transform: rotate(0);
      color: ${props => props.theme.colors.black};
    }
    
    &.active {
      .icon {
        transform: rotate(180deg);
      }
    }
  }

  .diet-icon {
    margin-left: .5rem;
    max-width: 20px;
  }

  .dish-title, 
  .dish-price {
    font-family: ${props => props.theme.font.family.black};
    font-size: ${props => props.theme.font.size.base};
  }

  ${props => props.$size === "sm" && css`
    .dish-price {
      font-size: ${props => props.theme.font.size.sm};
    }
  `}

  .dish-description {
    ${props => props.theme.font.size.base};
    ul {
      margin-bottom: .5rem;
    }
    ul, p {
      font-size: ${props => props.theme.font.size.base};
    }

    ${props => props.$size === "sm" && css`
      ul, p {
        font-size: ${props => props.theme.font.size.sm};
      }
    `}
  }

  .dish-contains  {
    font-size: ${props => props.theme.font.size.base};
    margin: 0;

    ${props => props.$size === "sm" && css`
      font-size: ${props => props.theme.font.size.sm};
    `}
  }

  .allergen-info {
    border-top: 2px solid black;
    padding-top: 1rem;
    padding-bottom: 0;
  }
`

export default function MenuDishes({title, dishes, menuId, size="base", defaultOpen=false}) {
  let allergenList = ""
  let allergensArray = []

  dishes?.forEach((dish, i) => {
    dish.dishAllergens?.nodes?.forEach((allergen, j) => {
      if (allergensArray.indexOf(allergen.name) <= -1) {
        allergensArray.push(allergen.name)
      }
    })
    dish.dishMayContains?.nodes?.forEach((allergen, j) => {
      if (allergensArray.indexOf(allergen.name) <= -1) {
        allergensArray.push(allergen.name)
      }
    })
  })

  allergensArray.forEach((allergen, i) => {
    allergenList += `${allergen}${allergensArray.length > i+1 ? ", " : ""}`
  })

  return(
    <DishesWrap $size={size}>
      {title && (
        <h3>{title}</h3>
      )}
      {dishes?.map((item, i) => {
        return <Dish 
          item={item} 
          menuTitle={title}
          key={i} 
          defaultOpen={defaultOpen} 
          menuId={menuId} 
        />
      })}

      {allergenList !== "" && (
        <div className="content-items allergen-info">
          <button id={`allergenInfo${menuId}`} className="dish-button">
            <FontAwesomeIcon icon={faAngleDown} className="icon dish-button-icon" />
            <span className="dish-title">Allergen Info</span>
          </button>
          <UncontrolledCollapse toggler={`#allergenInfo${menuId}`}>
            <div className="pt-2 dish-description">
              All dishes prepared by {title} may contain {allergenList}
            </div>
          </UncontrolledCollapse>
        </div>
      )}
    </DishesWrap>
  )
}

const Dish = ({item, menuTitle, defaultOpen, menuId}) => {
  const dishId = `dish${menuId}${item.id}`
  const [active, setActive] = useState(defaultOpen)
  const { dishesOpen = [], setDishesOpen } = useDishContext() || {};
  
  useEffect(() => {
    if (dishesOpen?.includes(dishId) || defaultOpen) {
      setActive(true)
    }
  }, [])

  const toggle = (id) => {
    document.getElementById(id).classList.toggle("active")
    setActive(!active)
    if (dishesOpen && setDishesOpen) {
      setDishesOpen(dishesOpen.includes(id) ? dishesOpen.filter(dish => dish !== id) : [...dishesOpen, id])
    }

    // Google Analytics Event to track menu dish button clicks
    if (window.gtag && !active) {
      window.gtag('event', 'menu_click', {
        'event_category': 'Menu Button Click',
        'event_label': `${menuTitle} - ${item.title}`,
        'debug_mode': true
      });
    }
  }

  return(
    <div className="content-items">
      <Row>
        <Col>
          <button 
            id={dishId} 
            onClick={() => toggle(dishId)} 
            className="dish-button" 
          >
            <FontAwesomeIcon icon={faAngleDown} className="icon dish-button-icon" />
            <div className="dish-title text-left">{item.title}
              {item.dishDiets?.nodes?.length > 0 && (
                <>
                  {item.dishDiets?.nodes?.map(diet => {
                    return(
                      <img 
                        key={diet.databaseId} 
                        src={diet.acfDishDiet.icon.localFile.publicURL} 
                        alt={diet.name} 
                        className="diet-icon" 
                      />
                    )
                  })}
                </>
              )}
            </div>
          </button>
        </Col>
        <Col xs="auto">
          <div dangerouslySetInnerHTML={{ __html: item.acfDish.price }} className="dish-price" />
        </Col>
      </Row>
      <Collapse isOpen={active}>
        {item.acfDish?.description && (
          <div dangerouslySetInnerHTML={{ __html: LinkSearchReplace(item.acfDish?.description) }} className="pt-2 dish-description"/>
        )}
        {item.dishAllergens?.nodes?.length > 0 && (
          <p className="dish-contains"><em>CONTAINS: {item.dishAllergens?.nodes?.map((allergen, i) => `${allergen.name}${item.dishAllergens?.nodes.length > i+1 ? ", " : ""}`)}</em></p>
        )}
      </Collapse>
    </div>
  )
}